import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PageTitle, PageLink } from "../layout/core/PageData";
// Legacy import (commented out)
// import ChatWrapper from "../layout/chat-handle/components/ChatWrapper.v2";
import { ChatWrapper } from "src/app/modules/chat/pages";

const HandleChat: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="d-flex flex-column w-100 h-100 row-gap-3 overflow-scroll">
      {/* <PageTitle>{t("SideBar.MenuItem.HC")}</PageTitle> */}
      <ChatWrapper />
    </div>
  );
};

export { HandleChat };
